import { Client } from '@langchain/langgraph-sdk'
import { OpenAPI } from '@om1/falcon-api'
import { useEffect, useState } from 'react'

export function useAuthenticatedClient(apiUrl: string) {
    const token = OpenAPI.TOKEN ? String(OpenAPI.TOKEN) : null
    const [client, setClient] = useState<Client | null>(null)

    useEffect(() => {
        const initClient = async () => {
            try {
                const newClient = new Client({
                    apiUrl: apiUrl || (process.env.REACT_APP_FALCON_AGENT_API_URL as string),
                    defaultHeaders: { Authorization: `Bearer ${token}` }
                })
                setClient(newClient)
            } catch (error) {
                console.error('Error initializing client with auth token:', error)
            }
        }

        initClient()
    }, [apiUrl, token])

    return client
}
